import { Scale, ShieldAlert, GitMerge, Sprout } from 'lucide-react';
import type { BoardFocusArea } from '../types/content';

export const boardFocusAreas: BoardFocusArea[] = [
  {
    icon: Scale,
    title: 'Corporate Governance',
    description:
      'Providing clear oversight, accountability and sound judgement across strategic, operational and organizational decisions.'
  },
  {
    icon: ShieldAlert,
    title: 'Risk, Resilience & Change',
    description:
      'Helping organizations navigate structural change, technological disruption, competitive pressure and evolving market conditions while protecting continuity and long-term value.'
  },
  {
    icon: GitMerge,
    title: 'Strategic Partnerships, M&A & Alliances',
    description:
      'Evaluating transactions, partnerships and joint ventures through the lens of strategic fit, commercial value, execution capability and sustainable return.'
  },
  {
    icon: Sprout,
    title: 'Sustainable Enterprise Growth',
    description:
      'Balancing near-term performance with investment discipline, organizational capability, customer value and long-term resilience.'
  }
];
